import { identity } from 'fp-ts/lib/function';

/**
 * @deprecated We now handle all uncaught errors by window error and unhandledrejection
 * event handlers in App.js, so we don't need to wrap event handlers with this function anymore.
 */
const handleEvent = identity;

export default handleEvent;
